// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__r3pu_","tutorial":"Links_tutorial__RPBSa","tutorial_white":"Links_tutorial_white__2FG6_","community":"Links_community__mthqP","link":"Links_link__3WDhT"};